module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Tab', {
    attrs: {
      "title": _vm.$trad.brand.navigation.access
    }
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t("brandadmin.title")) + " "), (_vm.required) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('p', {
    class: {
      error: _vm.error
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "buttonSelect",
    attrs: {
      "size": 'xs',
      "background-color": "grey"
    },
    on: {
      "click": function($event) {
        _vm.updateGlobalValue();
      }
    }
  }, [(_vm.allApplicationsAreSelected) ? [_vm._v("\n                    " + _vm._s(_vm.$t("common.selectNone")) + "\n                ")] : [_vm._v("\n                    " + _vm._s(_vm.$t("common.selectAll")) + "\n                ")]], 2)], 1)]), _vm._v(" "), _c('section', _vm._l((_vm.applications), function(app) {
    return _c('div', {
      key: app.value,
      staticClass: "checkbox"
    }, [_c('label', {
      staticClass: "pointer label-checkbox d-flex align-items-center",
      attrs: {
        "for": ("brandAccess-" + (app.value))
      }
    }, [_c('input', {
      ref: ("brandAccess-" + (app.value)),
      refInFor: true,
      staticClass: "col-auto d-none",
      attrs: {
        "type": "checkbox",
        "id": ("brandAccess-" + (app.value))
      },
      domProps: {
        "checked": _vm.applicationSelected(app.value) && _vm.applicationActive(app.value)
      },
      on: {
        "input": function (e) { return _vm.selectValue(app.value, e); }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.applicationSelected(app.value) && _vm.applicationActive(app.value)),
        expression: "applicationSelected(app.value) && applicationActive(app.value)"
      }],
      staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
    }, [_c('i', {
      staticClass: "fa fa-check fa-xs"
    })]), _vm._v(" "), (!_vm.applicationSelected(app.value) || !_vm.applicationActive(app.value)) ? _c('span', {
      staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "uppercase app-title"
    }, [_vm._v(_vm._s(app.label))])]), _vm._v(" "), (_vm.applicationSelected(app.value) && _vm.applicationActive(app.value) && app.parameters.length > 0) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-2"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-10 container-parameters"
    }, _vm._l((app.parameters), function(param) {
      return _c('label', {
        staticClass: "row label-checkbox parameter d-flex align-items-center mb-0 pointer",
        attrs: {
          "for": ("app_" + (app.value) + "_param_" + (param.id))
        }
      }, [_c('div', {
        staticClass: "col d-flex align-items-center"
      }, [_c('span', [_vm._v(_vm._s(_vm.getTranslate(param.terms.name)))])]), _vm._v(" "), (param.comment) ? _c('div', {
        staticClass: "col-auto"
      }, [_c('span', {
        staticClass: "small"
      }, [_vm._v(_vm._s(_vm.getTranslate(param.terms.comment)))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "mr-5",
        class: param.type === 'textarea' ? 'col-12 text-right' : 'col-auto'
      }, [(param.type === 'boolean') ? [_c('input', {
        staticClass: "d-none",
        attrs: {
          "id": ("app_" + (app.value) + "_param_" + (param.id)),
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.getAppParamValue(app.value, param)
        },
        on: {
          "input": function($event) {
            _vm.updateParamValue($event, app, param);
          }
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.getAppParamValue(app.value, param)),
          expression: "getAppParamValue(app.value, param)"
        }],
        staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
      }, [_c('i', {
        staticClass: "fa fa-check fa-xs"
      })]), _vm._v(" "), (!_vm.getAppParamValue(app.value, param)) ? _c('span', {
        staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
      }) : _vm._e()] : _vm._e(), _vm._v(" "), (param.type === 'number') ? _c('input', {
        directives: [{
          name: "digitsonly",
          rawName: "v-digitsonly",
          value: ({
            min: 1,
            max: 36
          }),
          expression: "{ min: 1, max: 36 }"
        }],
        staticClass: "input-number",
        attrs: {
          "id": ("app_" + (app.value) + "_param_" + (param.id)),
          "type": "text"
        },
        domProps: {
          "value": _vm.getAppParamValue(app.value, param)
        },
        on: {
          "input": function($event) {
            _vm.updateParamValue($event, app, param);
          }
        }
      }) : _vm._e(), _vm._v(" "), (param.type === 'text') ? _c('input', {
        attrs: {
          "id": ("app_" + (app.value) + "_param_" + (param.id)),
          "type": "text"
        },
        domProps: {
          "value": _vm.getAppParamValue(app.value, param)
        },
        on: {
          "input": function($event) {
            _vm.updateParamValue($event, app, param);
          }
        }
      }) : _vm._e(), _vm._v(" "), (param.type === 'textarea') ? _c('textarea', {
        staticClass: "w-100 mt-2",
        attrs: {
          "id": ("app_" + (app.value) + "_param_" + (param.id))
        },
        domProps: {
          "value": _vm.getAppParamValue(app.value, param)
        },
        on: {
          "input": function($event) {
            _vm.updateParamValue($event, app, param);
          }
        }
      }) : _vm._e()], 2)])
    }))])]) : _vm._e()])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eb7828c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/tabs/BrandAccess.vue
// module id = 3292
// module chunks = 0